<template>
	<page-text>
		<h1>Правила использования сертификата</h1>
	</page-text>
</template>

<script>
import PageText from 'elysium-common/components/page/text';
import VueRouter from 'vue-router';

export default {
	components: {
		PageText
	},
	asyncData({ store, route, router, http }) {
		const { rulesPfdodFileUrl } = store.state.regionProfile;
		if (rulesPfdodFileUrl) {
			return Promise.reject({
				message: 'Moved Permanently',
				code: 301,
				data: rulesPfdodFileUrl,
			});
		}

		return Promise.resolve();
	}
};
</script>



// WEBPACK FOOTER //
// Cert.vue?083d1138